import { ConversationAuditLogEntry } from 'apis/auditLogs';

import { LogEntry } from './logEntry';

type ConversationChannelUpdatedProps = {
  entry: ConversationAuditLogEntry<'CONVERSATION_CHANNEL_CHANGED'>;
};

export const ConversationChannelUpdated = ({
  entry,
}: ConversationChannelUpdatedProps): JSX.Element => {
  const text = <>Conversation channel updated to {entry.channel_reference}</>;
  return <LogEntry entry={entry} text={text} />;
};
